import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";

export default function MobileTabs({

    tabs,

    active,

    setActive

}) {

    return (

        <div className="mobile-tabs">

            <Swiper

                slidesPerView={"auto"}

                spaceBetween={8}

            >

                {tabs.map((tab, index) => (

                    <SwiperSlide

                        key={tab.id}

                        style={{

                            width: "auto"

                        }}

                    >

                        <button

                            className={active === index ? "active" : ""}

                            onClick={() => setActive(index)}

                        >

                            {tab.title}

                        </button>

                    </SwiperSlide>

                ))}

            </Swiper>

        </div>

    )

}